import { styled } from "@sourceful/shared-components";
import { SanityGridSection } from "@sourceful/shared-types";
import BasePageSection from "../BasePageSection";
import CardRow from "./CardRow";
import BannerRow from "./BannerRow";
import InfoBlockRow from "./InfoBlockRow";

const Grid = styled("div", {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  justifyContent: "center",

  variants: {
    hasGap: {
      true: {
        gridGap: "$inline_m1",
      },
    },
  },
});

interface GridSectionProps {
  section: SanityGridSection;
}

export const GridSection = ({ section }: GridSectionProps) => {
  const { rows, gridGap, constrainContent = true } = section;

  return (
    <BasePageSection section={section}>
      {rows && (
        <Grid hasGap={gridGap}>
          {rows?.map(row => {
            switch (row._type) {
              case "cardRow":
                return (
                  <CardRow
                    key={row._key}
                    widgets={row?.items || []}
                    hasGridGap={gridGap}
                    constrainContent={constrainContent}
                  />
                );
              case "infoBlockRow":
                return (
                  <InfoBlockRow
                    key={row._key}
                    widgets={row?.items || []}
                    hasGridGap={gridGap}
                    textAlign={row.textAlign}
                    layout={row.layout}
                    constrainContent={constrainContent}
                  />
                );
              case "bannerRow":
                return <BannerRow key={row._key} banners={row?.items || []} gridGap={gridGap} />;
              default:
                return null;
            }
          })}
        </Grid>
      )}
    </BasePageSection>
  );
};

export default GridSection;
